const landingTypes = [
  { label: 'Landing Standard', value: 'standard' },
  { label: 'Landing Corredor', value: 'broker' }
];

export default landingTypes;
